"use client";
import { useAppPlatformContextOptions } from './AppContextFactory2.js';

const useErrorsResponseTransform = (translationSuffix, useWholeTranslationSuffix, defaultErrorCode) => {
    const { translate } = useAppPlatformContextOptions();
    const getErrorMessages = (responseError) => {
        var _a;
        let result = [];
        if (responseError) {
            const fetchErrors = responseError;
            const errorsData = fetchErrors === null || fetchErrors === void 0 ? void 0 : fetchErrors.data;
            let serverSideErrors;
            if (Array.isArray(errorsData)) {
                serverSideErrors = errorsData;
            }
            else {
                serverSideErrors = errorsData === null || errorsData === void 0 ? void 0 : errorsData.errors;
            }
            if (!fetchErrors && !!(serverSideErrors === null || serverSideErrors === void 0 ? void 0 : serverSideErrors.length) && defaultErrorCode) {
                // add the default error code if no error returned
                serverSideErrors = (_a = mapUIError([defaultErrorCode]).data) === null || _a === void 0 ? void 0 : _a.errors;
            }
            if (serverSideErrors && Array.isArray(serverSideErrors)) {
                result = serverSideErrors.map((error) => ({
                    code: error.code,
                    field: error.field,
                    message: error.message
                        ? error.message
                        : translate(`${useWholeTranslationSuffix ? '' : 'common:shared.error-messages.'}${translationSuffix ? `${translationSuffix}.` : ''}${error.code}`),
                }));
            }
            else if (fetchErrors) {
                let status = `${fetchErrors.status}`;
                switch (status) {
                    case '401':
                        status = 'Unauthorized';
                        break;
                    case 'FETCH_ERROR':
                        status = 'FETCH_ERROR';
                        break;
                    default:
                        status = 'Server500';
                        break;
                }
                result = [
                    {
                        code: status,
                        message: fetchErrors.status ? translate(`common:shared.error-messages.${status}`) : '',
                        field: '',
                    },
                ];
            }
        }
        return result;
    };
    const mapUIError = (codes) => {
        return {
            status: '',
            data: {
                errors: codes.map((code) => ({
                    code,
                    field: '',
                    message: '',
                })),
            },
        };
    };
    return {
        getErrorMessages,
        mapUIError,
    };
};

export { useErrorsResponseTransform };
